<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <CK_scondHero />
        <CK_highLights :clientWidth="clientWidth"/>
        <CK_twoTout />


        <div>CentralKitchen</div>


    </main>

</template>


<script>
    import CK_scondHero from "../../components/content/enterprise/overView/CK_scondHero";
    import CK_highLights from "../../components/content/enterprise/overView/CK_highLights";
    import CK_twoTout from "../../components/content/enterprise/overView/CK_twoTout";


    export default {
        name: 'CentralKitchen',
        components: {
            CK_scondHero,
            CK_highLights,
            CK_twoTout,

        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methoCK: {

        }

    }
</script>

<style>


</style>
